import { Appearance } from "shared/appearance";

const SchoolAppearanceButton = () => {
  return <Appearance />;
};

export default SchoolAppearanceButton;